import {Injectable} from '@angular/core';
import * as logManager from './log.manager';
import {HttpObservable, HttpWrapper} from "../http-helpers/http.wrapper";

/**
 ****************************************************************
 * Proxy class for getting logger configuration from server.
 *
 * Written by: Stanislav Korobov
 ****************************************************************
 */
@Injectable({
  providedIn: 'root'
})
export class LogProxy {
  constructor(private httpWrapper: HttpWrapper) {
  }

  public getLogConfig():HttpObservable<logManager.ILoggerConfig> {
    return this.httpWrapper.get("PatientPortalLog", "GetLoggerAnonimous", null, null);
  }
}
